
import React, { useState, useCallback } from 'react'
import styled from 'styled-components'

import useAllowanceVote from '../../../hooks/nft/useAllowanceVote'
import { stopPropagation } from '../../../utils/func'
import useModal from '../../../hooks/bakery/useModal'
import VoteModal from '../../../pages/BakeryArtworks/components/VoteModal'
import useApproveVote from '../../../hooks/nft/useApproveVote'
import useVoting from '../../../hooks/nft/useVoting'

import { ButtonConfirmed } from '../../Button'
import Loader from '../../Loader'

const VoteFlag = styled(ButtonConfirmed)`
  position: absolute;
  font-size: 14px;
  z-index: 1;
  top: 26px;
  right: 26px;
  width: auto;
  height: 28px;
  border-radius: 6px;
  font-family: Baloo Da;
  text-align: center;
  padding: 0 17px;
  white-space: nowrap;
  color: ${({ theme }) => theme.bsText7};
  background: ${({ theme }) => theme.bsText9};
  &:hover{
    background: ${({ theme }) => theme.bsText9};
  }
`
const VoteAutoRow = styled.div`
  flex-wrap: nowrap;
  justify-content: center;
  display:flex;
  align-items:center;
`

export default function VoteBtn ({artwork, marketType}: {artwork: any, marketType: any}) {
  const allowanceVote = useAllowanceVote()
  const handVote = ((event: any) => {
    stopPropagation(event)
    onVoting()
  })

  //授权投票
  const [requestedApprovalVote, setRequestedApprovalVote] = useState(false)
  const onApproveVote = useApproveVote()
  const handleApproveVote = useCallback(async (event) => {
    stopPropagation(event)
    try {
      setRequestedApprovalVote(true)
      const txHash = await onApproveVote()
      if (!txHash) {
        setRequestedApprovalVote(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApproveVote, setRequestedApprovalVote])

  // 投票
  const {onVote} = useVoting(artwork.tokenId, marketType, artwork.owner) 
  const handleVote = useCallback(async (amount: string) => {
    try {
      const txHash = await onVote(amount)
      console.log('txHash', txHash)
    } catch (e) {
      console.log(e)
    }
  }, [onVote])

  const [onVoting] = useModal(
    <VoteModal
      onConfirm={handleVote}
      tokenId={artwork.tokenId}
      name={artwork.name}
      nftType={artwork.nftType}
      nftId={artwork.nftId}
    />
  )
  return <>
    {
      allowanceVote?.toNumber() 
      ? 
      <VoteFlag onClick={handVote}>Vote</VoteFlag>
      : 
      <VoteFlag
        onClick={handleApproveVote}
        disabled={requestedApprovalVote}
        altDisabledStyle={requestedApprovalVote}
      >
        {
          requestedApprovalVote ? (
            <VoteAutoRow>
              Approving <Loader stroke="white" />
            </VoteAutoRow>
          ) : 'Approve Vote'
        }
      </VoteFlag>
    }
  </>
}